import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const DatePickerComponent = React.forwardRef((props: any, ref) => {
  const internalRef = React.useRef<any>(null);
  const dateRef = ref || internalRef;
  const {
    sx,
    value,
    onChange,
    change,
    format,
    min,
    max,
    enabled = true,
    disabled,
    placeholder,
    floatLabelType: _floatLabelType,
    ...otherProps
  } = props;

  // Convert syncfusion format to dayjs format
  const convertFormat = (syncFormat: string | undefined) => {
    if (!syncFormat) return "DD-MMM-YY";
    // Common syncfusion to dayjs format conversions
    return syncFormat
      .replace(/dd/g, "DD")
      .replace(/MMM/g, "MMM")
      .replace(/MM/g, "MM")
      .replace(/yy/g, "YY")
      .replace(/yyyy/g, "YYYY");
  };

  const handleChange = (newValue: any) => {
    const dateValue = newValue ? newValue.toDate() : null;
    if (newValue && (!newValue.isValid?.() || !dayjs.isDayjs(newValue))) {
      return;
    }
    if (newValue && min && dayjs(newValue).startOf("day").isBefore(dayjs(min).startOf("day"))) {
      return;
    }
    if (newValue && max && dayjs(newValue).startOf("day").isAfter(dayjs(max).startOf("day"))) {
      return;
    }
    // Support both onChange and change (syncfusion uses 'change')
    if (onChange) {
      onChange({ value: dateValue, target: { value: dateValue } });
    }
    if (change) {
      change({
        value: dateValue,
        element: { ej2_instances: [{ id: props.id }] },
      });
    }
  };

  const isDisabled = disabled !== undefined ? disabled : !enabled;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={{
          width: "100%",
          "&.MuiFormControl-root .MuiInputBase-root": {
            height: "2rem",
            background: "white",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--info-light-blue)",
            borderWidth: "0.0625rem",
          },
          ...sx,
        }}
        {...otherProps}
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        minDate={min ? dayjs(min) : undefined}
        maxDate={max ? dayjs(max) : undefined}
        format={convertFormat(format)}
        disabled={isDisabled}
        slotProps={{
          textField: {
            placeholder: placeholder,
            size: "small",
          },
        }}
        ref={dateRef}
      />
    </LocalizationProvider>
  );
});

DatePickerComponent.displayName = "DatePickerComponent";
export default DatePickerComponent;
